import {
  getValidAssetDetailsPlanned,
  getAutoCompleteAssetPlanned,
  getCatalogItemDetails,
  GetVehicleTypeDropdown,
  setSelectedBranchDetails,
  setValidAssetDetailsPlanned,
  setSelectedVehicleType,
  getReasonTypes,
  setItemDetailsGrowth,
  setOrderDetails,
  GetPreferredModelDropdown,
  setReasonInfo,
  setAddClickFlg,
  GetBranch,
  BranchDetails,
  GetAddOrder,
  setFilteredCatalogItemValues,
  setCreateOrderCompleteFlg,
  getUploadedBlobUrlList,
  setUploadedBlobUrlList,
  setUploadFilesComplete,
  getAssestTypes,
  getEquipmentDropdown,
  getSeatingCapacityDropdown,
  getUtilityManufactureDropdown,
  getUtilityEnclosedcabDropdown,
  getUtilityCapacityDropdown,
  getTrailerManufactureDropdown,
  getTrailerStyleDropdown,
  getTrailerLengthDropdown,
  getTrailerChargingstationDropdown,
  getSnowManufactureDropdown,
  getSnowCategoryDropdown,
  getTrailerFuelTankDropdown,
  getSnowSizeDropdown,
  getSnowTypeDropdown,
  getSnowParentVehicleDropdown,
  getDevelopmentCategoryDropdown,
  getDevelopmentManufactureDropdown,
  getTreeManufactureDropdown,
  getTreeEquipmentDropdown,
  getTreeHorsePowerDropdown,
  getTreeFuelTypeDropdown,
  getStandardManufactureDropdown,
  getStandardCategoryDropdown,
  setUploadedAttachmentDetails,
  getStateAvailability,
  getProgramStatus,
  getAnnualHours,
  getDeckSize,
  getDeckType,
  getAutonomous,
  getManufacturerDropDown,
  getCategoryDropDown,
  setEditClickFlg,
  setEditVehicleIndex,
  setEditReasonValue,
  getReasonStatusDropdown,
  getReasonConditionDropdown,
  getDropdownsBySubType,
  appendDropdownData,
  setAutoCompleteAssetPlanned,
  requestCostCenters,
} from "./action";


const dispatchGetValidAssetDetailsPlanned =
  (dispatch: Function) => (assetId: any) => {
    dispatch(getValidAssetDetailsPlanned(assetId));
  };

const dispatchGetAutoCompleteAssetPlanned =
  (dispatch: Function) => (assetId: any) => {
    dispatch(getAutoCompleteAssetPlanned(assetId));
  };

const dispatchGetCatalogItemDetails =
  (dispatch: Function) => (catalogRequestBody: {}) => {
    dispatch(getCatalogItemDetails(catalogRequestBody));
  };

const dispatchGetVehicleTypeDropdown =
  (dispatch: Function) => (assetTypeId: number) => {
    dispatch(GetVehicleTypeDropdown(assetTypeId));
  };

const dispatchSetSelectedBranchDetails =
  (dispatch: Function) => (selectedBranchDetails: any) => {
    dispatch(setSelectedBranchDetails(selectedBranchDetails));
  };

const dispatchSetValidAssetDetailsPlanned =
  (dispatch: Function) => (validAssetDetailsPlanned: any) => {
    dispatch(setValidAssetDetailsPlanned(validAssetDetailsPlanned));
  };

const dispatchSetSelectedVehicleType =
  (dispatch: Function) => (selectedVehicleType: any) => {
    dispatch(setSelectedVehicleType(selectedVehicleType));
  };

const dispatchGetStateAvailability = (dispatch: Function) => () => {
  dispatch(getStateAvailability());
};

const dispatchGetReasonTypes = (dispatch: Function) => () => {
  dispatch(getReasonTypes());
};

const dispatchSetOrderDetails = (dispatch: Function) => (orderDetails: any) => {
  dispatch(setOrderDetails(orderDetails));
};

const dispatchSetItemDetailsGrowth = (dispatch: Function) => (value: any) => {
  dispatch(setItemDetailsGrowth(value));
};

const dispatchGetPreferredModelDropdown =
  (dispatch: Function) => (assertMakeId: number) => {
    dispatch(GetPreferredModelDropdown(assertMakeId));
  };

const dispatchSetReasonInfo = (dispatch: Function) => (reasonInfo: any) => {
  dispatch(setReasonInfo(reasonInfo));
};

const dispatchSetAddClickFlg =
  (dispatch: Function) => (addClickFlg: boolean) => {
    dispatch(setAddClickFlg(addClickFlg));
  };

const dispatchGetBranch = (dispatch: Function) => (user: any) => {
  dispatch(GetBranch(user));
};

const dispatchBranchDetails = (dispatch: Function) => (branch: any) => {
  dispatch(BranchDetails(branch));
};

const dispatchGetAddOrder = (dispatch: Function) => (order: any) => {
  dispatch(GetAddOrder(order));
};

const dispatchSetFilteredCatalogItemValues =
  (dispatch: Function) => (filteredCatalogItemValues: any) => {
    dispatch(setFilteredCatalogItemValues(filteredCatalogItemValues));
  };
const dispatchAssestTypes = (dispatch: Function) => () => {
  dispatch(getAssestTypes());
};

const dispatchSetCreateOrderCompleteFlg =
  (dispatch: Function) => (isCreateOrderComplete: any) => {
    dispatch(setCreateOrderCompleteFlg(isCreateOrderComplete));
  };

const dispatchGetUploadedBlobUrlList =
  (dispatch: Function) => (fileObj: any) => {
    dispatch(getUploadedBlobUrlList(fileObj));
  };

const dispatchSetUploadedBlobUrlList =
  (dispatch: Function) => (BlobUrlListObj: any) => {
    dispatch(setUploadedBlobUrlList(BlobUrlListObj));
  };

const dispatchSetUploadFilesComplete =
  (dispatch: Function) => (isUploadComplete: any) => {
    dispatch(setUploadFilesComplete(isUploadComplete));
  };

const dispatchGetEquipmentDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getEquipmentDropdown(assetSubTypeId));
  };
const dispatchGetSeatingCapacityDropdown = (dispatch: Function) => () => {
  dispatch(getSeatingCapacityDropdown());
};
const dispatchGetUtilityManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getUtilityManufactureDropdown(assetSubTypeId));
  };
const dispatchGetUtilityEncloseCabDropdown = (dispatch: Function) => () => {
  dispatch(getUtilityEnclosedcabDropdown());
};
const dispatchGetUtilityCapacityDropdown = (dispatch: Function) => () => {
  dispatch(getUtilityCapacityDropdown());
};
const dispatchGetTrailerManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getTrailerManufactureDropdown(assetSubTypeId));
  };

const dispatchGetTrailerStyleDropdown = (dispatch: Function) => () => {
  dispatch(getTrailerStyleDropdown());
};

const dispatchGetTrailerLengthDropdown = (dispatch: Function) => () => {
  dispatch(getTrailerLengthDropdown());
};

const dispatchGetTrailerFuelTankDropdown = (dispatch: Function) => () => {
  dispatch(getTrailerFuelTankDropdown());
};
const dispatchGetTrailerChargingStationDropdown =
  (dispatch: Function) => () => {
    dispatch(getTrailerChargingstationDropdown());
  };
const dispatchGetSnowManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getSnowManufactureDropdown(assetSubTypeId));
  };
const dispatchGetSnowcategoryDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getSnowCategoryDropdown(assetSubTypeId));
  };
const dispatchGetSnowsizeDropdown = (dispatch: Function) => () => {
  dispatch(getSnowSizeDropdown());
};
const dispatchGetSnowtypeDropdown = (dispatch: Function) => () => {
  dispatch(getSnowTypeDropdown());
};
const dispatchGetSnowparentVehicleDropdown = (dispatch: Function) => () => {
  dispatch(getSnowParentVehicleDropdown());
};
const dispatchGetDevelopmentCategoryDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getDevelopmentCategoryDropdown(assetSubTypeId));
  };
const dispatchGetDevelopmentManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getDevelopmentManufactureDropdown(assetSubTypeId));
  };
const dispatchGetTreeManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getTreeManufactureDropdown(assetSubTypeId));
  };
const dispatchGetTreeEquipmentDropdown = (dispatch: Function) => () => {
  dispatch(getTreeEquipmentDropdown());
};
const dispatchGetTreeHorsePowerDropdown = (dispatch: Function) => () => {
  dispatch(getTreeHorsePowerDropdown());
};
const dispatchGetTreeFuelTypeDropdown = (dispatch: Function) => () => {
  dispatch(getTreeFuelTypeDropdown());
};
const dispatchGetStandardManufactureDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getStandardManufactureDropdown(assetSubTypeId));
  };
const dispatchGetStandardCategoryDropdown =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getStandardCategoryDropdown(assetSubTypeId));
  };
const dispatchGetProgramStatus = (dispatch: Function) => () => {
  dispatch(getProgramStatus());
};
const dispatchGetAnnualHours = (dispatch: Function) => () => {
  dispatch(getAnnualHours());
};
const dispatchGetDeckSize = (dispatch: Function) => () => {
  dispatch(getDeckSize());
};
const dispatchGetDeckType = (dispatch: Function) => () => {
  dispatch(getDeckType());
};
const dispatchGetAutonomous = (dispatch: Function) => () => {
  dispatch(getAutonomous());
};
const dispatchGetManufacturer =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getManufacturerDropDown(assetSubTypeId));
  };
const dispatchGetCategory =
  (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getCategoryDropDown(assetSubTypeId));
  };

const dispatchSetUploadedFileDetails =
  (dispatch: Function) => (uploadedAttachmentDetails: any) => {
    dispatch(setUploadedAttachmentDetails(uploadedAttachmentDetails));
  };
const dispatchSetEditClickFlg =
  (dispatch: Function) => (editClickFlg: boolean) => {
    dispatch(setEditClickFlg(editClickFlg));
  };
const dispatchSetEditVehicleIndex =
  (dispatch: Function) => (editVehicleIndex: number) => {
    dispatch(setEditVehicleIndex(editVehicleIndex));
  };

const dispatchSetEditReasonValue =
  (dispatch: Function) => (editReasonValues: any) => {
    dispatch(setEditReasonValue(editReasonValues));
  };
const dispatchGetReasonStatusDropdown = (dispatch: Function) => () => {
  dispatch(getReasonStatusDropdown());
};
const dispatchGetReasonConditionDropdown = (dispatch: Function) => () => {
  dispatch(getReasonConditionDropdown());
};

const dispatchGetDropdownsBySubType = (dispatch: Function) => (subTypeId: any) => {
  dispatch(getDropdownsBySubType(subTypeId));
};

const dispatchAppendDropdownData = (dispatch: Function) => (obj: any) => {
  dispatch(appendDropdownData(obj));
};

const dispatchAutoCompleteAssetPlanned = (dispatch: Function) => (obj: any) => {
  dispatch(setAutoCompleteAssetPlanned(obj));
};


export const dispatchRequestCostCenters = (dispatch: Function) => (id?: string) => dispatch(requestCostCenters(id));

const operations = {
  dispatchGetValidAssetDetailsPlanned,
  dispatchGetAutoCompleteAssetPlanned,
  dispatchGetCatalogItemDetails,
  dispatchGetVehicleTypeDropdown,
  dispatchSetSelectedBranchDetails,
  dispatchSetValidAssetDetailsPlanned,
  dispatchSetSelectedVehicleType,
  dispatchSetOrderDetails,
  dispatchGetPreferredModelDropdown,
  dispatchGetReasonTypes,
  dispatchSetItemDetailsGrowth,
  dispatchSetReasonInfo,
  dispatchSetAddClickFlg,
  dispatchGetBranch,
  dispatchBranchDetails,
  dispatchGetAddOrder,
  dispatchSetFilteredCatalogItemValues,
  dispatchSetCreateOrderCompleteFlg,
  dispatchGetUploadedBlobUrlList,
  dispatchSetUploadedBlobUrlList,
  dispatchSetUploadFilesComplete,
  dispatchAssestTypes,
  dispatchGetEquipmentDropdown,
  dispatchGetSeatingCapacityDropdown,
  dispatchGetUtilityManufactureDropdown,
  dispatchGetUtilityEncloseCabDropdown,
  dispatchGetUtilityCapacityDropdown,
  dispatchGetTrailerManufactureDropdown,
  dispatchGetTrailerStyleDropdown,
  dispatchGetTrailerLengthDropdown,
  dispatchGetTrailerFuelTankDropdown,
  dispatchGetTrailerChargingStationDropdown,
  dispatchGetSnowManufactureDropdown,
  dispatchGetSnowcategoryDropdown,
  dispatchGetSnowsizeDropdown,
  dispatchGetSnowtypeDropdown,
  dispatchGetSnowparentVehicleDropdown,
  dispatchGetDevelopmentCategoryDropdown,
  dispatchGetDevelopmentManufactureDropdown,
  dispatchGetTreeManufactureDropdown,
  dispatchGetTreeEquipmentDropdown,
  dispatchGetTreeHorsePowerDropdown,
  dispatchGetTreeFuelTypeDropdown,
  dispatchGetStandardManufactureDropdown,
  dispatchGetStandardCategoryDropdown,
  dispatchSetUploadedFileDetails,
  dispatchGetStateAvailability,
  dispatchGetProgramStatus,
  dispatchGetAnnualHours,
  dispatchGetDeckSize,
  dispatchGetDeckType,
  dispatchGetAutonomous,
  dispatchGetManufacturer,
  dispatchGetCategory,
  dispatchSetEditClickFlg,
  dispatchSetEditVehicleIndex,
  dispatchSetEditReasonValue,
  dispatchGetReasonStatusDropdown,
  dispatchGetReasonConditionDropdown,
  dispatchGetDropdownsBySubType,
  dispatchAppendDropdownData,
  dispatchAutoCompleteAssetPlanned,
};

export default operations;
